"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrderTracker = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var _settings = require("../../settings");

var useOrderTracker = function useOrderTracker(uniqueOrderNumber) {
  var _a, _b;

  var settings = (0, _settings.useSettings)().data;
  var refetchInterval = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.CONFIG) === null || _a === void 0 ? void 0 : _a.ORDER_TRACKER) === null || _b === void 0 ? void 0 : _b.REFETCH_INTERVAL;
  return (0, _reactQuery.useQuery)("OrderTrackerData"
  /* OrderTrackerData */
  , function () {
    return (0, _api.fetchOrderTracker)(uniqueOrderNumber);
  }, {
    refetchInterval: refetchInterval,
    retry: false
  });
};

exports.useOrderTracker = useOrderTracker;